import { DataService } from '../../services/data_service';
import { EigenstromButtonWrapper } from '../dateneingabe/assistent/items/wrapper/EigenstromButtonWrapper';
import { FileUploadDialog } from '../../core/fileupload/FileUploadDialog';
import { getStandorte } from '../../helpers/getStandorte';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { ImportAufnahmebogen } from './routinen/ImportAufnahmebogenNeu';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import style from '../../default.less';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WActionButton } from '../../core/elements/WActionButton';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
import { ZusatztoolsToolExcelImportVorschau } from './import/ZusatztoolsToolExcelImportVorschau';

interface ZusatztoolsToolExcelImportProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    standortSelected: any;
    onDone?: (jahrMin: number) => void;
    doneText?: string;
}

interface ZusatztoolsToolExcelImportState {
    dataImport: any;
    dataImportIgnored: any;
    dataLoaded: string;
    eigenstromtypen: Array<any>
    eigenstromtypTid: number;
    hasEigenstromtypen: boolean;
    isLoaded: boolean;
    isLoading: boolean;
    isSaved: boolean;
    isSaving: boolean;
    standortSelected: any;
}

export class ZusatztoolsToolExcelImport extends React.Component<ZusatztoolsToolExcelImportProps, ZusatztoolsToolExcelImportState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataImport: {},
            dataImportIgnored: {},
            dataLoaded: null,
            eigenstromtypen: [],
            eigenstromtypTid: undefined,
            hasEigenstromtypen: undefined,
            isLoaded: false,
            isLoading: false,
            isSaved: false,
            isSaving: false,
            standortSelected: this.props.standortSelected || (this.props.data[IDs.ENT_STANDORT] || [])[0] || {}
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.onImport = this.onImport.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private hasErneuerbareEnergien: boolean;

    componentDidMount(): void {
        this.hasErneuerbareEnergien = (this.props.data[IDs.ENT_KONFIGURATION] || [])
            .some((param: any) => param.daten_erneuerbare_energien_orig === 1);

        if (this.hasErneuerbareEnergien) {
            this.init();
        }
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        if (this.hasErneuerbareEnergien && this.state.standortSelected !== prevState.standortSelected) {
            this.init();
        }
    }

    getEigenstromtypen(): Array<any> {
        const anlagen_eigenstrom_typen: Array<any> = (this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN] || [])
            .filter((item: any) => (item.typ || null) === 'S')
            .map((item: any) => item.tid);

        return (this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM] || [])
            .filter((item: any) =>
                (+item.standort_tid_orig || null) === (+(this.state.standortSelected || {}).tid || null)
                && anlagen_eigenstrom_typen.indexOf(+item.anlagen_eigenstrom_typ_tid_orig || null) !== -1
            )
            .sort((a: any, b: any) => (a.anlagen_eigenstrom_typ_tid || '').toString().trim().toLowerCase().localeCompare(
                (b.anlagen_eigenstrom_typ_tid || '').toString().trim().toLowerCase())
            );
    }

    init(): void {
        const eigenstromtypen: Array<any> = this.getEigenstromtypen();

        if (eigenstromtypen.length === 1) {
            this.setState({
                eigenstromtypen, eigenstromtypTid: eigenstromtypen[0].anlagen_eigenstrom_typ_tid_orig || undefined, hasEigenstromtypen: true
            });
        } else if (!eigenstromtypen.length) {
            this.setState({ eigenstromtypen, eigenstromtypTid: undefined, hasEigenstromtypen: false });
        } else {
            this.setState({ eigenstromtypen, eigenstromtypTid: -1, hasEigenstromtypen: true });
        }
    }

    onDataLoaded(dataLoaded: string): void {
        this.setState(
            { dataLoaded, isLoaded: true, isLoading: false },
            () => this.setImport()
        );
    }

    onImport(): void {
        const entities: Array<any> = Object.keys(this.state.dataImport);
        let counter: number = entities.length;

        if (!entities.length) {
            this.setState({ isSaved: true });
            return;
        }

        if (
            this.state.hasEigenstromtypen && (this.state.dataImport[IDs.ENT_ENERGIEDATEN_EIGENSTROM] || []).length
            && (+this.state.eigenstromtypTid || -1) === -1
        ) {
            alert('Bitte wählen Sie eine Stromerzeugungsanlage aus.');
            return;
        } else if (!this.state.hasEigenstromtypen && (this.state.dataImport[IDs.ENT_ENERGIEDATEN_EIGENSTROM] || []).length) {
            alert('Bitte legen Sie eine Stromerzeugungsanlage an.');
            return;
        }

        const setEntity = (entity: string) => {
            this.setData(
                entity || null,
                (data: any, success: boolean) => {
                    if (success) {
                        this.triggerService.fire('reload', entity);
                    }

                    if (!--counter) {
                        const dataImport = this.state.dataImport;
                        this.setState({ dataImport: {}, isLoaded: false, isSaved: true, isSaving: false });
                        const jahrMin = this.setAnzeigeJahrVon(dataImport);

                        if (this.props.doneText) {
                            alert(this.props.doneText.replace(/\\n/g, '\n'));
                        } else {
                            alert('Die Daten wurden gespeichert.');
                        }

                        if (this.props.onDone) {
                            this.props.onDone(jahrMin);
                        }
                    }
                }
            );
        };
        this.setState({ isSaving: true });

        entities.forEach((entity: string) => setEntity(entity));
    }

    render(): JSX.Element {
        if (!this.props.data) {
            return <div>Lade...</div>;
        }

        return (
            <div style={{ padding: 20 }}>
                <div style={{ minWidth: 200, maxWidth: 800, display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
                    <div style={{ fontSize: '9pt', padding: '0 5px' }}>
                        Mit diesem Tool können Sie Daten aus einer in Ihrem Betrieb bereits geführten Excel-Version des Energiebuch E-Tools
                        in die vorliegende Anwendung übertragen; dies ist möglich für die Excel E-Tool Versionen 1.5 / 1.5.1 / 1.6.! Sollten
                        Sie sich dafür interessieren auch andere Dateiformate zu übertragen, bitte {this.renderKontaktLink()}.
                    </div>
                    <div
                        className={style.infofield}
                        style={{
                            display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center',
                            boxSizing: 'border-box', color: 'white', backgroundColor: '#f79646'
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
                            <div style={{ minHeight: 32, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                {this.renderStandortAuswahl()}
                            </div>
                            {this.hasErneuerbareEnergien &&
                                <div style={{ minHeight: 32, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    {this.renderEigenstromAuswahl()}
                                </div>
                            }
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', overflowX: 'hidden' }}>
                                {this.renderDateiAuswahl()}
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
                            {(Object.keys(this.state.dataImport).length > 0) &&
                                this.renderImportButton()
                            }
                        </div>
                    </div>
                </div>
                {this.state.isLoaded && this.renderErgebnis()}
                {this.state.isLoading && <WSpinner label='Laden' />}
                {this.state.isSaving && <WSpinner label='Senden' />}
            </div>
        );
    }

    renderDateiAuswahl(): JSX.Element {
        return (
            <>
                <div style={{ width: 140, margin: '0 5px' }}>
                    Datei:
                </div>
                <FileUploadDialog
                    onDataLoaded={this.onDataLoaded}
                    onDataSelected={() => this.setState({ isLoading: true })}
                />
            </>
        );
    }

    renderErgebnis(): JSX.Element {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', marginTop: '1em', marginBottom: '1em' }}>
                <ZusatztoolsToolExcelImportVorschau
                    data={this.state.dataImport}
                    dataIgnored={this.state.dataImportIgnored}
                    dataDb={this.props.data}
                />
             </div>
        );
    }

    renderImportButton(): JSX.Element {
        return (
            <WActionButton
                label='Importieren'
                key='import'
                action='import'
                onAction={() => this.onImport()}
                insideText='Importieren'
                disabled={this.state.isSaved}
                styleProps={{ fontSize: 'larger', border: '2px solid #6692c3', borderRadius: 0 }}
            />
        );
    }

    renderKontaktLink(): JSX.Element {
        return (
            <span
                style={{ textDecoration: 'underline', color: '#6692c3', cursor: 'pointer' }}
                title='Kontakt / Ansprechpartner:in'
                onClick={() => this.props.onRoutingChange({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_KONTAKTE })}
            >
                kontaktieren Sie uns
            </span>
        );
    }

    renderEigenstromAuswahl(): JSX.Element {
        return (
             <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', overflowX: 'hidden' }}>
                <div style={{ width: 140, margin: '0 5px' }}>
                    Stromerzeugungsanlage:
                </div>
                <select
                    style={{ maxWidth: 300, width: 300 }}
                    value={this.state.eigenstromtypTid || undefined}
                    disabled={this.state.eigenstromtypen.length < 2}
                    onChange={(event: any) => {
                        this.setState({ eigenstromtypTid: +event.target.value },
                            () => {
                                if (this.state.isLoaded) {
                                    this.setImport();
                                }
                            }
                        );
                    }}
                >
                    {!this.state.eigenstromtypen.length &&
                        <option>Nicht verfügbar</option>
                    }
                    {this.state.eigenstromtypen.length > 1 &&
                        <option
                            key='eigenstromtyp-'
                            value={-1}
                        >
                            {`<${i18n('keine Auswahl', 'sys')}>`}
                        </option>
                    }
                    {this.state.eigenstromtypen.map((eigenstrom: any, index: number) =>
                        <option
                            key={`eigenstromtyp-${index}`}
                            value={eigenstrom.anlagen_eigenstrom_typ_tid_orig || undefined}
                        >
                            {eigenstrom.anlagen_eigenstrom_typ_tid || null}
                        </option>
                    )}
                </select>
                <EigenstromButtonWrapper
                    data={this.props.data}
                    onChange={() => this.init()}
                    standortSelected={this.state.standortSelected}
                />
            </div>
        );
    }

    renderStandortAuswahl(): JSX.Element {
        const standorte: any[] = getStandorte(this.props.data) || [];

        return (
             <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', overflowX: 'hidden' }}>
                <div style={{ width: 140, margin: '0 5px' }}>
                    Standort:
                </div>
                <select
                    style={{ maxWidth: 300, width: 300 }}
                    value={this.state.standortSelected.tid || null}
                    disabled={standorte.length < 2}
                    onChange={(event: any) => {
                        const standortSelected: any = standorte.find((standort: any) => +standort.tid === +event.target.value) || {};
                        this.setState({ standortSelected },
                            () => {
                                if (this.state.isLoaded) {
                                    this.setImport();
                                }
                            }
                        );
                    }}
                >
                    {!standorte.length &&
                        <option>Nicht verfügbar</option>
                    }
                    {standorte.map((standort: any, index: number) =>
                        <option
                            key={`standort-${index}`}
                            value={standort.tid || undefined}
                        >
                            {standort.name || null}
                        </option>
                    )}
                </select>
            </div>
        );
    }

    setData(entity: string, callback?: (data: any, success: boolean) => void): void {
        const data: Array<any> = (this.state.dataImport)[entity] || [];

        data.forEach((row: any, index: number) => {
            data[index].standort_tid = +(this.state.standortSelected || {}).tid || null;

            if ([IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_WAERME, IDs.ENT_ENERGIEDATEN_WASSER].indexOf(entity) !== -1) {
                data[index].abrechnungsart = 1; // {1} Reguläre Abrechnung
            }

            if (entity === IDs.ENT_ENERGIEDATEN_EIGENSTROM && (+this.state.eigenstromtypTid || -1) !== -1) {
                data[index].anlagen_eigenstrom_typ_tid = +this.state.eigenstromtypTid;
            }
        });
        this.dataService.saveDataList(
            entity, data,
            (sql: string, success: boolean) => {
                if (typeof callback === 'function') {
                    callback(data, success);
                }
            },
            IDs.MOD_ETOOL
        );
    }

    setImport(): void {
        const data: any = this.props.data || {};
        const Import = new ImportAufnahmebogen(
            this.state.dataLoaded,
            {
                ...data,
                [IDs.ENT_ENERGIEDATEN_STROM]: data[IDs.ENT_ENERGIEDATEN_STROM]
                    .filter((element: any) => (element.standort_tid_orig || null) === this.state.standortSelected.tid),
                [IDs.ENT_ENERGIEDATEN_EIGENSTROM]: data[IDs.ENT_ENERGIEDATEN_EIGENSTROM]
                    .filter((element: any) => (element.standort_tid_orig || null) === this.state.standortSelected.tid),
                [IDs.ENT_ENERGIEDATEN_WAERME]: data[IDs.ENT_ENERGIEDATEN_WAERME]
                    .filter((element: any) => (element.standort_tid_orig || null) === this.state.standortSelected.tid),
                [IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE]: data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE]
                    .filter((element: any) => (element.standort_tid_orig || null) === this.state.standortSelected.tid),
                [IDs.ENT_ENERGIEDATEN_WASSER]: data[IDs.ENT_ENERGIEDATEN_WASSER]
                    .filter((element: any) => (element.standort_tid_orig || null) === this.state.standortSelected.tid),
                [IDs.ENT_BETRIEBSDATEN]: data[IDs.ENT_BETRIEBSDATEN]
                    .filter((element: any) => (element.standort_tid_orig || null) === this.state.standortSelected.tid),
                [IDs.ENT_SONSTIGE_DATEN]: data[IDs.ENT_SONSTIGE_DATEN]
                    .filter((element: any) => (element.standort_tid_orig || null) === this.state.standortSelected.tid)
            }
        );
        const strom: any = Import.getStrom() || [];
        const stromIgnored: any = Import.getStromIgnored() || [];

        if (!this.hasErneuerbareEnergien) {
            delete strom[IDs.ENT_ENERGIEDATEN_EIGENSTROM];
            delete stromIgnored[IDs.ENT_ENERGIEDATEN_EIGENSTROM];
        }
        this.setState({
            dataImport: {
                ...strom,
                ...Import.getWaerme() || [],
                ...Import.getKraftstoffe() || [],
                ...Import.getWasser() || [],
                ...Import.getBwl() || [],
                ...Import.getBerater() || []
            },
            dataImportIgnored: {
                ...stromIgnored,
                ...Import.getWaermeIgnored() || [],
                ...Import.getKraftstoffeIgnored() || [],
                ...Import.getWasserIgnored() || [],
                ...Import.getBwlIgnored() || [],
                ...Import.getBeraterIgnored() || []
            }
        }, () => {
            // console.log('VERSION: ', Import.version, 'IMPORT: ', this.state.dataImport, 'IGNORED: ', this.state.dataImportIgnored);
            if (!Object.keys(this.state.dataImport).length) {
                alert('Es wurden keine Datensätze im Aufnahmebogen gefunden.');
            }
        });
    }

    setAnzeigeJahrVon(dataImport: any): number {
        const konfiguration: any = (this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const dateneingabe_von: number = +konfiguration.dateneingabe_form_jahr_von || null;
        const startjahr_datenerfassung: number = +konfiguration.startjahr_datenerfassung || null;
        const tid: number = +konfiguration.tid || null;
        // console.log('DATIMP', dataImport);
        // alert('Prüfe Startjahr');
        let minJahr: number = dateneingabe_von;

        Object.keys(dataImport || {}).forEach((key: string) => {
            dataImport[key].forEach((item: any) => {
                if (+item.jahr < minJahr || (minJahr === null && +item.jahr >= startjahr_datenerfassung)) {
                    minJahr = item.jahr;
                }
            });
        });
        console.log('MinJahr: ', minJahr, dateneingabe_von, konfiguration);
        if (minJahr && (dateneingabe_von === null || (dateneingabe_von > minJahr))) {
            this.dataService.setData(
                IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION,
                { tid, dateneingabe_form_jahr_von: minJahr },
                () => this.triggerService.fire('reload', IDs.ENT_KONFIGURATION)
            );
            // alert(`Im Rahmen des Imports wurde das "Startjahr der Datenerfassung" von [${dateneingabe_von}] auf [${minJahr}] geändert.`);
        }
        return minJahr;
    }
}
